import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { eventUpdate } from '~SpectateStore/actions/eventUpdate';
import { marketSwitcherUpdate } from '~SpectateStore/actions/marketSwitcherUpdate';
import { storeCleanup } from '~SpectateStore/actions/storeCleanupActions';
import {
    moreGamesUpdate,
} from '~SpectateStore/actions/moreGamesActions';
import {
    dataPointersUpdate,
} from '~SpectateStore/actions/dataPointersActions';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';

export const SLICE_NAME = 'marketsEvents';

export const marketsEventsAdapter = createEntityAdapter();

const marketsEventsSlice = createSlice({
    name: SLICE_NAME,
    initialState: marketsEventsAdapter.getInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                storeCleanup,
                (state, { payload : { eventIds } }) => {
                    const idsForDeletion = [];

                    state.ids.forEach(marketEventId => {
                        const marketEvent = state.entities[marketEventId];
                        if (eventIds.includes(marketEvent.event_id)) {
                            idsForDeletion.push(marketEvent.id);
                        }
                    });

                    if (idsForDeletion.length) {
                        marketsEventsAdapter.removeMany(state, idsForDeletion);
                    }
                },
            )
            .addCase(
                inplayEventData.fulfilled,
                (state, { payload : { markets_events } }) => {
                    if (Object.keys(markets_events).length > 0) {
                        return marketsEventsAdapter.addMany(state, markets_events);
                    }

                    return state;
                },
            )
            .addCase(
                eventUpdate,
                (state, { payload : { marketsEvents } }) => {
                    if (marketsEvents.length >= 1) {
                        return marketsEventsAdapter.upsertMany(state, marketsEvents);
                    }

                    return state;
                },
            )
            .addCase(
                moreGamesUpdate,
                (state, { payload : { marketsEvents } }) => {
                    marketsEventsAdapter.addMany(state, marketsEvents);
                },
            )
            .addCase(
                dataPointersUpdate,
                (state, { payload : { marketsEvents = {}, marketsEventsToBeRemoved = [] } }) => {
                    if (marketsEventsToBeRemoved.length) {
                        marketsEventsAdapter.removeMany(state, marketsEventsToBeRemoved);
                    }

                    if (Object.keys(marketsEvents).length > 0) {
                        return marketsEventsAdapter.addMany(state, marketsEvents);
                    }

                    return state;
                },
            )
            .addCase(
                marketSwitcherUpdate,
                (state, { payload: { marketsEvents } }) => {
                    // Replace the entire collection with a new set of entities
                    marketsEventsAdapter.setAll(state, marketsEvents);
                }
            )
            .addCase(
                eventInplayStart,
                (state, { payload : { marketsEvents } }) => {
                    marketsEventsAdapter.addMany(state, marketsEvents);
                }
            );
    },
});

export default marketsEventsSlice.reducer;
